import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Postulaciones } from 'src/app/models/postulaciones/postulaciones.model';
import { ConsultaPrestamosService } from 'src/app/services/consulta-prestamos/consulta-prestamos.service';
import { ConsultaPostulacionesService } from 'src/app/services/consulta-postulaciones/consulta-postulaciones.service';
import { TiposService } from 'src/app/services/tipos/tipos.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { DialogEditPrestamo } from 'src/app/components/prestamos/prestamos-validar.component';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';
import { DialogEditPrestamoEjecutivo } from 'src/app/components/prestamos/prestamos-confirmar.component';
import { ModalInfoBeneficiario } from '../common/modal-info-beneficiario.component';
import { ModalInfoRechazoBeneficiario } from '../common/modal-info-rechazo-beneficiario.component';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { ModalInfoPagadaBeneficiario } from '../common/modal-info-pagada-beneficiario.component';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-consulta-prestamos',
  templateUrl: '../../pages/consulta-prestamos/consulta-prestamos.component.html',
  styleUrls: ['../../pages/consulta-prestamos/consulta-prestamos.component.css']
})
export class ConsultaPrestamosComponent implements OnInit {
  prestamos: any
  postulaciones: any
  email: any
  postulacionesFinales: any
  postulacionSeleccionada: any
  allComplete: boolean = false
  rol: string = localStorage.getItem("rol")
  idUsuario: string = localStorage.getItem("idUsuario");
  //config: any = { itemsPerPage: 5, currentPage: 1, totalItems: 5 }
  config: any = { itemsPerPage: 5, currentPage: 1, totalItems: 5, indexInicial: 0, indexMaximo: 5 }
  tipoPostulacion: string = "Disponibles"
  idEjecutivo = localStorage.getItem("idUsuario")
  solicitud: any
  data: any
  regiones: any
  estado: any
  buscador: any =
    {
      rut: '', region: '0', fechaInicio: '', fechaFin: '', itemsPerPage: 5, currentPage: 1, idSolicitud: '',
      estado: ['INGRESADA', 'DISPONIBLE PARA PAGO', 'PAGADA VIGENTE', 'PAGADA CERRADA', 'RECHAZADA', 'APROBADA', 'PENDIENTE', 'ANULADA'],
      paginasTotal: 5, estadoselect: ['INGRESADA']
    }
  tipos: any
  cuotas: any
  totalMaximo: any
  recarga: any

  constructor(public router: Router,
    public consultaPrestamosService: ConsultaPrestamosService,
    public consultaPostulacionesService: ConsultaPostulacionesService,
    private dialog: MatDialog, private tiposService: TiposService) { }

  ngOnInit(): void { this.loadData() }

  loadData() {
    let vm = this;
    vm.solicitud = 'prestamo'
    vm.recarga = false
    if (this.rol == 'ROLE_AFILIADO' || this.rol == 'ROLE_JUBILADO') {
      this.postulacionesDisponibles();
    }
    else {
      this.consultaPrestamosService.traeRegiones().then(regiones => this.regiones = regiones).catch(error => console.log(error))

      this.consultaPrestamosService.traeEstados().then(estado => this.estado = estado).catch(error => console.log(error))

      this.postulacionesDisponiblesBuscador(false);
    }

  }

  openEditDialog(idPostulacion: any, nombreProducto: any, mostrarEditar?: any, disponiblePago?: any): void {
    this.openDialogPrestamo(idPostulacion, mostrarEditar, disponiblePago);


  }
  detalleBeneficiario(rutAfiliado: any) {
    let data: any = {}

    this.consultaPrestamosService.traeUsuario(rutAfiliado.split('-')[0]).then
      (
        (usu: any) => {
          console.log(usu)

          data.nombre = usu.nombres + usu.apellidoPaterno + usu.apellidoMaterno
          data.telefono = usu.telefonoFijo
          data.celular = usu.telefonoMovil
          data.mail = usu.email
          data.prevision = usu.prevision
          data.beneficiarios = usu.carga
        }
      )
      .catch(error => console.log(error))

    const dialogRef = this.dialog.open(ModalInfoBeneficiario, { width: '40%', data: data })

    dialogRef.afterClosed().subscribe(() => { })
  }

  detalleRechazoBeneficiario(idPostulacion: any)
  {
    Swal.fire({
      allowOutsideClick:false,
      icon:'info',
      text:'Cargando...'
    });
    Swal.showLoading();

      let data: any = { }

      this.consultaPostulacionesService.traeDataRechazo(idPostulacion).then
      (
          (postulacion: any) =>
          {
              console.log(postulacion)
              data.tipoRechazo=postulacion.motivoRechazo
              data.comentarioRechazo=postulacion.descripcionRechazo
           
          }
      )
      .catch(error => console.log(error))
      Swal.close();
      const dialogRef = this.dialog.open(ModalInfoRechazoBeneficiario, { width: '40%', data: data })

      dialogRef.afterClosed().subscribe( () => {  })
  }

  detalleSolicitudPagada(idPostulacion: any)
  {
    Swal.fire({
      allowOutsideClick:false,
      icon:'info',
      text:'Cargando...'
    });
    Swal.showLoading();

      let data: any = { }

      this.consultaPostulacionesService.traeDataPagada(idPostulacion).then
      (
          (postulacion: any) =>
          {
              console.log(postulacion)
              data.idGrupo=postulacion.id
              data.fechaPago=postulacion.fechaRespuesta           
          }
      )
      .catch(error => console.log(error))
      Swal.close();
      const dialogRef = this.dialog.open(ModalInfoPagadaBeneficiario, { width: '40%', data: data })

      dialogRef.afterClosed().subscribe( () => {  })
  }
  openDialogPrestamo(idPostulacion: any, mostrarEditar?: any, disponiblePago?: any) {
    let vm = this

    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();
    let mostrarAprobarButton = true;
    let mostrarEnviarButton = true;
    if (disponiblePago) {
      mostrarAprobarButton = false;
      mostrarEnviarButton = false;

      if (localStorage.getItem("rol") == 'ROLE_ADMINISTRADOR') {
        disponiblePago = false;
        mostrarAprobarButton = true;
        mostrarEnviarButton = true;
      }

    }
    this.consultaPrestamosService.traeTipoPrestamo().then(tipo => this.tipos = tipo).catch(error => console.log(error))

    this.consultaPrestamosService.traeCantidadCuotas().then(cuota => this.cuotas = cuota).catch(error => console.log(error))

    this.consultaPrestamosService.traeMontoTotalDisponible(this.idEjecutivo).then(response => {
      this.totalMaximo = response;
    }
    ).catch(error => {
      console.log(error);
      this.totalMaximo = 0;
    });
    this.consultaPrestamosService.traePrestamoGestionar(idPostulacion, mostrarEditar).then
      (
         
        (response: any) => {
          let data: any =
          {
            archivos: response.archivoAdjunto,
            tipos: this.tipos,
            cuotas: this.cuotas,
            totalMaximo: this.totalMaximo,
            idPrestamo: response.idPrestamo,
            idPostulacion: response.idPostulacion,
            nombreUsuario: response.nombreUsuario,
            apellidoUsuario: response.apellidoUsuario,
            idCodeudor1: response.idCodeudorUno,
            idCodeudor2: response.idCodeudorDos,
            rutCodeudor1: response.rutCodeudorUno,
            rutCodeudor2: response.rutCodeudorDos,
            nombreCodeudor1: response.nombreCodeudorUno,
            nombreCodeudor2: response.nombreCodeudorDos,
            apellidoCodeudor1: response.apellidoCodeudorUno,
            apellidoCodeudor2: response.apellidoCodeudorDos,
            rutUsuario: response.rutUsuario,
            cantidadCuotas: response.cantidadCuota,
            montoCuota: response.totalCuota,
            fechaIngreso: response.fechaIngreso,
            fechaPrimerPago: response.fechaPrimerPago,
            montoSolicitado: response.montoSolicitado,
            tipoPrestamo: response.tipoPrestamo,
            deshabilitado: true,
            presionaEditar: false,
            idCantidadCuotas: response.idCantidadCuotas,
            idUsuario: response.idUsuario,
            montoTotalCuota: response.montoTotalCuota,
            mostrarEditar: mostrarEditar,
            disponiblePago: !disponiblePago,
            mostrarAprobarButton: mostrarAprobarButton,
            asientoContable: response.asientoContable,
            estado: response.estado

          }

          let vm = this

          const dialogRef = vm.dialog.open(DialogEditPrestamoEjecutivo, {
            width: '45%', data: data
          })
          Swal.close();

          dialogRef.afterClosed().subscribe(() => {
            if(vm.tipoPostulacion=='Asignadas'){
              vm.postulacionesAsignadas(false)
            }else{
              vm.postulacionesDisponibles(false)
            }
            
          })
        }
      )
      .catch(error => {
        console.log(error);
        Swal.close();
      })
  }




  buscar() {
    this.buscador.currentPage = 1, this.config.itemsPerPage = 5

    // this.buscador.cantidadPaginas=this.config.itemsPerPage
    if ((this.buscador.fechaInicio != '' && this.buscador.fechaFin == '')
      || (this.buscador.fechaInicio == '' && this.buscador.fechaFin != '')) {
      this.openAlertDialog('Favor seleccionar fecha de inicio y fecha fin.', 'btn-danger')
      return
    } else {
      if (this.buscador.fechaInicio != '' && this.buscador.fechaFin != '') {
        let fechaInicial = this.buscador.fechaInicio.split('-')
        let fechaFinal = this.buscador.fechaFin.split('-')

        if (parseInt(fechaInicial[0] + '' + fechaInicial[1] + '' + fechaInicial[2]) > parseInt(fechaFinal[0] + '' + fechaFinal[1] + '' + fechaFinal[2])) {

          this.openAlertDialog('Favor la fecha de inicio es mayor a la final.', 'btn-danger');
          this.buscador.fechaFin = "";
          return
        }
      }

      if (this.buscador.estadoselect.length == 0) {
        this.openAlertDialog('Favor seleccionar al menos un estado.', 'btn-danger')
        return
      }
    }
    if (this.tipoPostulacion == 'Disponibles') {
      this.postulacionesDisponiblesBuscador(false)
    } else {

      this.postulacionesAsignadas(false)
    }
  }
  asignaPostulacion(idPostulacion: any) {

    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();
    let postulacion = [{ id: idPostulacion }]
    let vm = this

    this.consultaPrestamosService.asignaPostulacion(postulacion, this.idEjecutivo).then
      (
        () => {
          if (vm.buscador.paginasTotal == 1 && vm.buscador.currentPage > 1) {

            vm.buscador.currentPage = vm.buscador.currentPage - 1;
            vm.config.currentPage = this.buscador.currentPage
          }
          vm.postulacionesDisponiblesBuscador(true)
          vm.openAlertDialog('La postulación se ha asignado exitosamente.', 'btn-success')
          Swal.close();
        }
      )
      .catch
      (
        error => {
          Swal.close();
          console.log(error)
          vm.openAlertDialog('La postulación no se ha podido asignar.', 'btn-danger')
        }
      )
  }


  postulacionesDisponiblesBuscador(recarga?: boolean) {

    let vm = this
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();

    vm.tipoPostulacion = 'Disponibles'
    vm.solicitud = 'prestamo'
    if (recarga) {
      vm.config.currentPage = 1, vm.buscador.currentPage = 1
      this.buscador.region = "0";
      this.buscador.estadoselect = ['INGRESADA'];
      this.buscador.rut = '';
      this.buscador.fechaInicio = '';
      this.buscador.fechaFin = '';
      this.buscador.idSolicitud = '';

    }

    this.buscador.estado = this.buscador.estadoselect;

    vm.consultaPrestamosService.postulacionesDisponiblesBuscador(this.idUsuario, this.rol, this.buscador, localStorage.getItem("username")).then(
      (postulaciones: any) => {
        postulaciones.resultado.forEach(postulacion => { postulacion.seleccionado = false })

        vm.postulaciones = postulaciones.resultado
        vm.buscador.paginasTotal = postulaciones.resultado.length
        vm.config.currentPage = this.buscador.currentPage
        vm.config.totalItems = postulaciones.cantidadRegistros
        postulaciones.cantidadPaginasTotal = postulaciones.cantidadRegistros / postulaciones.cantidadPaginas
        vm.buscador.paginasTotal = postulaciones.cantidadPaginas
        this.buscador.paginasTotal = postulaciones.cantidadPaginas
        if (this.buscador.currentPage < postulaciones.cantidadPaginasTotal && this.buscador.currentPage == 1) {
          this.config.itemsPerPage = postulaciones.resultado.length
        }
        Swal.close();




      }
    )
      .catch(error => {
        console.log(error)
        vm.prestamos = []

        vm.config.currentPage = 1
        vm.postulaciones = []
        vm.config.totalItems = 0

        Swal.close();
        this.openAlertDialog('No se pudo obtener las postulaciones disponibles.', 'btn-danger')
      })
  }

  postulacionesDisponibles(recargar?: boolean) {

    let vm = this
    this.tipoPostulacion = 'Disponibles'
    vm.solicitud = 'prestamo'
    if (recargar) {
      this.config.currentPage = 1, this.buscador.currentPage = 1
      this.buscador.region = "0";
      this.buscador.estadoselect = ['INGRESADA', 'PAGADA', 'DISPONIBLE PARA PAGO', 'APROBADA'];
      this.buscador.rut = '';
      this.buscador.fechaInicio = '';
      this.buscador.fechaFin = '';
      this.buscador.idSolicitud = '';
    }
    this.buscador.estado = this.buscador.estadoselect;

    vm.consultaPrestamosService.postulacionesDisponibles(this.idUsuario, this.rol).then(
      (prestamos: any) => {

        vm.prestamos = prestamos
        vm.buscador.paginasTotal = prestamos.length
        if (prestamos.resultado) {
          vm.buscador.paginasTotal = prestamos.resultado.length
        }
        vm.config.currentPage = this.buscador.currentPage
        vm.config.totalItems = prestamos.cantidadRegistros
      }
    )
      .catch(error => {
        console.log(error)
        vm.prestamos = []

        vm.config.currentPage = 1
        vm.postulaciones = []
        vm.config.totalItems = 0

        Swal.close();
        this.openAlertDialog('No se pudo obtener las postulaciones disponibles.', 'btn-danger')
      })
  }

  postulacionesAsignadas(recargar?: boolean) {

    this.tipoPostulacion = 'Asignadas'
    this.solicitud = 'prestamo'
    let vm = this
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();
    vm.tipoPostulacion = "Asignadas"

    if (recargar) {
      this.config.currentPage = 1,
        this.buscador.currentPage = 1
      this.buscador.region = "0";
      this.buscador.estadoselect = ['EN VALIDACION'];
      this.buscador.rut = '';
      this.buscador.fechaInicio = '';
      this.buscador.fechaFin = '';
      this.buscador.idSolicitud = '';
    }
    this.buscador.estado = this.buscador.estadoselect;

    this.consultaPrestamosService.traePostulacionesAsignadas(this.idUsuario, this.buscador, this.buscador.estadoselect).then
      (
        (postulaciones: any) => {

          vm.postulaciones = postulaciones.resultado
          vm.buscador.paginasTotal = postulaciones.resultado.length
          vm.config.currentPage = this.buscador.currentPage
          vm.config.totalItems = postulaciones.cantidadRegistros
          postulaciones.cantidadPaginasTotal = postulaciones.cantidadRegistros / postulaciones.cantidadPaginas
          vm.buscador.paginasTotal = postulaciones.cantidadPaginas
          this.buscador.paginasTotal = postulaciones.cantidadPaginas

          if (this.buscador.currentPage < postulaciones.cantidadPaginasTotal || this.buscador.currentPage == 1) {
            this.config.itemsPerPage = postulaciones.resultado.length
          }
          Swal.close();
        }
      )
      .catch(error => {
        console.log(error)
        vm.prestamos = []

        vm.config.currentPage = 1
        vm.postulaciones = []
        vm.config.totalItems = 0

        Swal.close();
      })
  }

  cargaSolicitudesCodeudor() {
    let vm = this;

    this.solicitud = 'codeudor'
    vm.idEjecutivo = localStorage.getItem("idUsuario")
    vm.consultaPrestamosService.postulacionesCodeudor(this.idUsuario).then(
      (prestamos: any) => {
        vm.prestamos = prestamos
        vm.idEjecutivo = localStorage.getItem("idUsuario")
        vm.config.currentPage = 1
        vm.config.totalItems = prestamos.length

      }
    )
      .catch(error => {
        console.log(error)
        Swal.close();
        this.openAlertDialog('No se pudo obtener las solicitudes de codeudor.', 'btn-danger')
      })
  }
  updateAllComplete() {
    this.allComplete = this.postulaciones != null && this.postulaciones
      .slice(this.config.indexInicial, this.config.indexMaximo)
      .every(p => p.seleccionado)
  }


  cargaSolicitudesDisponibles() {
    this.solicitud = 'prestamo'
    let vm = this;
    vm.consultaPrestamosService.postulacionesDisponibles(this.idUsuario, this.rol).then(
      (prestamos: any) => {
        vm.prestamos = prestamos

        vm.config.currentPage = 1
        vm.config.totalItems = prestamos.length
      }
    )
      .catch(error => {
        console.log(error)
        Swal.close();
        this.openAlertDialog('No se pudo obtener las postulaciones disponibles.', 'btn-danger')
      })
  }
  openDialogCodeudorPrestamo(postulacion: any, mostrarEditar: any) {
    let vm = this;
    this.consultaPrestamosService.traePrestamo(postulacion, mostrarEditar).then(
      (response: any) => {
        let data: any =
        {
          idPrestamo: response.idPrestamo,
          idPostulacion: response.idPostulacion,
          nombreUsuario: response.nombreUsuario,
          apellidoUsuario: response.apellidoUsuario,
          idCodeudor: this.idUsuario,
          rutUsuario: response.rutUsuario,
          cantidadCuota: response.cantidadCuota,
          idCantidadCuota: response.idCantidadCuota,
          montoCuota: response.totalCuota,
          fechaIngreso: response.fechaIngreso,
          fechaPrimerPago: response.fechaPrimerPago,
          montoSolicitado: response.montoSolicitado,
          tipoPrestamo: response.tipoPrestamo,
          mostrarEditar: mostrarEditar
        }


        const dialogRef = vm.dialog.open(DialogEditPrestamo,
          { width: '40%', data: data })

        dialogRef.afterClosed().subscribe(result => {

          if (data.recarga) {
            setTimeout(function () {
              console.log("recarga consulta:", data.recarga)
              vm.cargaSolicitudesCodeudor()
            }, 3000);

            // this.postulacionesAsignadas(true)
          }
          Swal.close();

        })

      }
    )
      .catch(error => {
        console.log(error)
        Swal.close();
        this.openAlertDialog('No se pudo obtener las postulaciones disponibles.', 'btn-dark')
      })


  }
  verArchivo(postulacionId: any) {
    let vm = this
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();
    this.consultaPrestamosService.traeArchivos(postulacionId).then
      (
        (archivos: any) => {
          archivos.forEach(archivo => {
            var fileURL = `${environment.urlBlob}/${archivo.url}`
            window.open(fileURL);
          })
          Swal.close();
        }
      )
      .catch(error => {
        console.log(error)
        Swal.close();
        vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
      })
  }

  asignarSeleccionados() {
    let postulacionesSeleccionadas: any = []

    this.postulaciones.filter(pos => pos.seleccionado).forEach(pos => {
      postulacionesSeleccionadas.push({ id: pos.id })
    })

    let vm = this

    if (postulacionesSeleccionadas.length == 0) {
      this.openAlertDialog("Debe seleccionar al menos una postulación.", "btn-danger")
      return
    }
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();

    this.consultaPrestamosService.asignaPostulacion(postulacionesSeleccionadas, this.idEjecutivo).then
      (
        () => {

          if (vm.buscador.paginasTotal == postulacionesSeleccionadas.length && vm.buscador.currentPage > 1) {
            vm.buscador.currentPage = vm.buscador.currentPage - 1;
            vm.config.currentPage = this.buscador.currentPage
          }
          vm.postulacionesDisponiblesBuscador(false);
          vm.openAlertDialog('La postulación se ha asignado exitosamente..', 'btn-success')
          Swal.close();
        }
      )
      .catch(error => {
        Swal.close();
        console.log(error)
        vm.openAlertDialog('Las postulaciones no se ha podido asignar.', 'btn-danger')
      })
  }

  openAlertDialog(mensaje: string, clase: string) {
    this.dialog.open(AlertDialogComponent, {
      data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
    })
  }
  /*
  pageChanged(event: any) {

    this.config.currentPage = event
    this.buscador.currentPage = event
    this.config.indexInicial = ((this.config.currentPage - 1) * this.config.itemsPerPage)
    this.config.indexMaximo = (this.config.currentPage * this.config.itemsPerPage)
   

  }
  */
  //pageChanged(event: any) { this.config.currentPage = event }

  pageChanged(event: any) {

    this.buscador.currentPage = event
    this.config.indexInicial = ((this.config.currentPage - 1) * this.config.itemsPerPage)
    this.config.indexMaximo = (this.config.currentPage * this.config.itemsPerPage)
    if (this.tipoPostulacion == 'Asignadas') {
      this.postulacionesAsignadas(false);
    } else {
      if (this.rol == 'ROLE_AFILIADO' || this.rol == 'ROLE_JUBILADO') {
        this.postulacionesDisponibles();
      }
      else {
        this.postulacionesDisponiblesBuscador(false);
      }
    }
  }

  someComplete(): boolean {
    if (isNullOrUndefined(this.postulaciones?.seleccionado)) { return false }

    return this.postulaciones.filter(p => p.seleccionado).length > 0 && !this.allComplete
  }
  setAll(seleccionado: boolean) {
    this.allComplete = seleccionado

    if (this.postulaciones == null) { return }

    this.postulaciones.forEach(pos => { pos.seleccionado = seleccionado })
  }

  openDialogAnular(idPostulacion: any, rut: any) {
    const dialogRef = this.dialog.open(ConfirmationDialog,
      {
        data: { message: '¿Esta seguro de anular la solicitud de Préstamo?', buttonText: { ok: 'Si', cancel: 'No' } }
      })

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {

        Swal.fire({
          allowOutsideClick: false,
          icon: 'info',
          text: 'Cargando...'
        });
        Swal.showLoading();
        let vm = this

        this.consultaPrestamosService.cambiarEstadoPostulacion(idPostulacion, "ANULADA").then
          (
            () => {
              vm.solicitud = 'prestamo'
              if (this.rol == 'ROLE_AFILIADO') {
                this.postulacionesDisponibles();
              }
              else {

                this.postulacionesDisponiblesBuscador(false);
              }

              Swal.close();
              vm.openAlertDialog('La postulación se ha anulado exitosamente.', 'btn-success')
            }
          )
          .catch
          (
            error => {

              Swal.close();
              console.log(error)
              vm.openAlertDialog('La postulación no se ha podido anular.', 'btn-danger')
            }
          )

      }
    })
  }

}